import {Component, inject, signal} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent} from '@angular/material/dialog';
import {MatButton} from '@angular/material/button';
import {TranslatePipe} from '@ngx-translate/core';
import {FormsModule} from '@angular/forms';
import {UserSelectionComponent} from '../user-selection/user-selection.component';
import {UserHal} from '../../models/HAL/user-hal.model';

@Component({
  selector: 'app-assign-case',
  imports: [
    MatDialogContent,
    MatDialogActions,
    MatDialogClose,
    MatButton,
    TranslatePipe,
    FormsModule,
    UserSelectionComponent
  ],
  templateUrl: './assign-case.component.html',
  styleUrl: './assign-case.component.scss'
})
export class AssignCaseComponent {
  protected data = inject(MAT_DIALOG_DATA);
  protected chosenUser: UserHal | null = null;
  protected teamId: string = "";
  protected preFilledUser = signal<UserHal | undefined>(undefined);
  protected assignMultiple: boolean = false;
  protected assignMultipleCount: number | null = null;

  constructor() {
    if (this.data?.user) {
      this.preFilledUser.set(this.data.user);
    }
    if (this.data?.teamId) {
      this.teamId = this.data.teamId;
    }
    this.assignMultiple = !!this.data?.assignMultiple;
    if (typeof this.data?.assignMultipleCount === 'number') {
      this.assignMultipleCount = this.data.assignMultipleCount;
    }
  }

  userSelected(user: UserHal) {
    this.chosenUser = user;
  }

  userDeselected() {
    this.chosenUser = null;
  }
}
